const navLinks = [
  { name: "Trang Chủ", href: "/" },
  { name: "Về Chúng Tôi", href: "/us", },
  { name: "Bài Viết", href: "/blog" },
  { name: "Sự Kiện", href: "/event" },
];

export default navLinks;
